<template>
    <window-portal :open="dataProps.show" @close="() => {
        dataProps.show = false
        if(dataProps?.closeCallback){
            dataProps?.closeCallback()
        };
    }
        ">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista previa de impresión de Cotización</p></div></center>
            <br/>
            <center>
                <button ref="btnPrint" class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button ref="btnDownload" class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                &nbsp;&nbsp;
                
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>
        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="margin: 0 auto; width: 1000px;">
                    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                        <div v-for="(page, indexPage) in pages" :key="indexPage" style="position: relative; width: 1000px; min-height: 1293px; background: white;">
                            <hr/>
                            <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                            
                                <div style="margin-left: 80px; margin-right: 50px;">
                                    
                                    <div ref="headerSection">
                                    <div style="width: 100%;">
                                        <table style="font-size: 10pt; border-collapse: collapse; width: 100%; vertical-align: top;">
                                            <tr style="padding-right: 20px; padding-bottom: 5px; color: white !important;">
                                                <td style="width: 250px;">
                                                    <img v-if="!showCanvas && logoImagePath" ref="logo" :src="logoImagePath" width="200px" height="auto" />
                                                </td>
                                                <td style="color: black; text-align: center; vertical-align: top;">
                                                    <template v-if="isBranchInfo">
                                                        <div v-html="modifiedBranchBilledInfo"></div>
                                                    </template>
                                                    <template v-else>
                                                        <div><b>{{ dataProps.data.businessInfo[0].BusinessName }}</b></div>
                                                        <div>{{ dataProps.data.businessInfo[0].DescActividad }}</div>
                                                        <div>{{ dataProps.data.businessInfo[0].BranchLegalAddress }}</div>
                                                        <div>Tel. {{ dataProps.data.businessInfo[0].BranchPhone }}</div>
                                                        <div>Whatsapp. {{ dataProps.data.businessInfo[0].BranchMobile }}</div>
                                                        <div>{{ dataProps.data.businessInfo[0].BranchEmail }}</div>
                                                        <div>NIT: {{ BillingNit }}</div>
                                                        <div>NRC: {{ BillingNrc }}</div>
                                                    </template>
                                                </td>
                                                <td style="color: black; text-align: end; width: 250px; vertical-align: top;">
                                                    Fecha: <b>{{ dataProps.data.quoteInfo.InvoiceDate }}</b>
                                                    <div>
                                                        <b>{{ dataProps.data.quoteInfo.ID_Invoice }}</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <hr/>

                                    <div style="width: 100%;">
                                        <table style="font-size: 10pt; border-collapse: collapse; width: 100%;">
                                            <tr>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>ID de Cliente:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.ID_Customer}}</td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>Nombre:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.InvoiceName}}</td>
                                            </tr> 
                                            <tr>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>DUI:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.InvoiceDUI || '---'}}</td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>NIT:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.InvoiceNIT || '---'}}</td>
                                            </tr>

                                            <tr>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>NRC:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.InvoiceNRC || '---'}}</td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>Dirección:</b></td>
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 300px !important;">{{dataProps.data.quoteInfo.InvoiceAddress || '---'}}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;"></td>
                                            </tr>
                                            <tr>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>ID del vendedor:</b></td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.ID_Seller || '---'}}</td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>Nombre del vendedor:</b></td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.FullName || '---'}}</td>
                                            </tr>
                                            <tr>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>Teléfono del vendedor:</b></td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.SellerMobile || '---'}}</td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>E-mail del vendedor:</b></td>
                                                <td  style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;">{{dataProps.data.quoteInfo.SellerEmail || '---'}}</td>
                                            </tr>
                                            <tr v-if="dataProps.data.quoteInfo.RulesToShowComments == 0 || dataProps.data.quoteInfo.RulesToShowComments == 2">
                                                <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;"><b>Comentarios:</b></td>
                                                <td colspan="3" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px;" v-html="comentarioFactura"></td>
                                            </tr>
                                        </table>
                                    </div>
                                    </div>

                                    <div style="width: 100%;">
                                        <table style="width: 100% !important; font-size: 11px; border-collapse: collapse; border: 1px solid black;">
                                            <thead ref="tableHeader">
                                            <tr style="background: gray;">
                                                <td colspan="9" style="text-align: center; color: white;">CUERPO DEL DOCUMENTO</td>
                                            </tr>

                                            <tr>
                                                <td style="border: 1px solid; padding-left: 2px; width: 35px;">No.<br/>Item</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 35px;">Cant.</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 95px;">Código</td>
                                                <td style="border: 1px solid; padding-left: 2px;">Descripcion</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 65px;">Precio<br/>unitario {{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 65px;">Descuento {{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 65px;">Ventas<br/>exentas {{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 65px;">Ventas no<br/>sujetas {{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                <td style="border: 1px solid; padding-left: 2px; width: 65px;">Ventas <br/>gravadas {{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                            </tr>
                                            </thead>
                                            <!--valuesRows[indexPage]-->
                                            <tr v-for="(item, index) in valuesRows[indexPage]" :key="index">
                                                <td style="border-left: 1px solid; border-right: 1px solid;">{{ (index+1)+(rowsPerPage*indexPage)+indexPage }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid;">{{ item.ItemQuantity }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid;">{{ item.ID_Item }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid;">{{ item.ItemDescription }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid; text-align: right;">{{ numberWithCommas(parseFloat(item.ItemUnitPrice).toFixed(2)) }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid; text-align: right;">{{ numberWithCommas(parseFloat(item.ItemDiscount).toFixed(2)) }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid; text-align: right;">{{ numberWithCommas(parseFloat(item.ItemExenta).toFixed(2)) }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid; text-align: right;">{{ numberWithCommas(parseFloat(item.ItemNoSuj).toFixed(2)) }}</td>
                                                <td style="border-left: 1px solid; border-right: 1px solid; text-align: right;">{{ numberWithCommas(parseFloat(item.ItemGravada).toFixed(2)) }}</td>
                                            </tr>

                                            <tbody ref="footerSection">
                                            <tr v-if="indexPage == (numPages-1)">
                                                <td colspan="4" style="text-align: center; border: 1px solid;"><b>Valor en letras: </b> {{dataProps.data.quoteInfo.InvoiceTotalLetras}}</td>

                                                <td colspan="5" style="border: 1px solid;">
                                                    <table style="width: 100% !important; font-size: 11px; text-align: right;">
                                                        <tr>
                                                            <td>Sub total</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceSubTotalVentas).toFixed(2))}}</td>
                                                        </tr> 
                                                        <tr>
                                                            <td>Total descuentos</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceTotalDescu).toFixed(2))}}</td>
                                                        </tr> 
                                                        <tr v-if="dataProps.data.quoteInfo.InvoiceType === 'CCF'">
                                                            <td>IVA</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceTotalIva).toFixed(2))}}</td>
                                                        </tr> 
                                                        <!-- <tr>
                                                            <td>Sub total</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceMontoTotalOperacion).toFixed(2))}}</td>
                                                        </tr> -->
                                                        <tr>
                                                            <td>IVA Retenido</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceIvaRete1).toFixed(2))}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>IVA Percibido</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceIvaPerce1).toFixed(2))}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Impuesto sobre la renta</td>
                                                            <td>{{dataProps.data.quoteInfo.InvoiceCurrency}}</td>
                                                            <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceReteRenta).toFixed(2))}}</td>
                                                        </tr>
                                                        <tr style="font-size: 12px;">
                                                            <td><b>Total</b></td>
                                                            <td><b>{{dataProps.data.quoteInfo.InvoiceCurrency}}</b></td>
                                                            <td style="text-align: right; width: 50px;"><b>{{numberWithCommas(parseFloat(dataProps.data.quoteInfo.InvoiceTotalPagar).toFixed(2))}}</b></td>
                                                        </tr> 
                                                    </table>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>
                                
                                <div style="position: absolute; bottom: 0; width: 100%; left: 80px">
                                    <p style="font-size:10px;">Pagina {{ indexPage+1 }} de {{ numPages }}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc"
import { numberWithCommas } from "../../helpers/money";
//import html2pdf from 'html2pdf.js'
//import {numberToText} from '@/helpers/conveterNumberText.js'

export default {
    name: "PrintQuotesBill2",
    props: ['dataProps'],
    components: {WindowPortal},
    data() {
        return {
            loading: false,
            numPages: 0,
            mailLabel: null,
            valuesRows: [],
            typePrint: 0,
            showCanvas: false,
            branchinfo: JSON.parse(localStorage.getItem("branch")),
            BranchBilledInfo: null,
            rowsPerPage: 15,
            PAGE_HEIGHT: 1170,
            ESTIMATED_FOOTER_HEIGHT: 200,
            TABLE_HEADER_HEIGHT: 55,
            ROW_HEIGHT: 22,
            logoImagePath: null,
        }
    },
    mounted() {
        this.BranchBilledInfo = this.branchinfo?.BranchBilledInfo || null;
    },
    computed: {
        comentarioFactura(){
            return this.dataProps.data.quoteInfo.InvoiceInternalNote 
            ? this.dataProps.data.quoteInfo.InvoiceInternalNote 
            : ''
        },
        fechadehoy() {
            return new Date();
        },
        BillingNrc() {
            return addFormatNRC(this.dataProps.data.businessInfo[0].BusinessBillingNRC)
        },
        BillingNit() {
            //console.log(this.dataProps.data.branch.BusinessBillingNIT);
            return addFormatToNIT(this.dataProps.data.businessInfo[0].BusinessBillingNIT)
        },
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
        isBranchInfo(){
            return this.BranchBilledInfo 
                    && this.BranchBilledInfo?.length > 0;
        },
        modifiedBranchBilledInfo() {
            let info = this.BranchBilledInfo;
            if (info && info?.length > 0) {
                info = info
                    .replace(/<p>/g, '')
                    .replace(/<\/p>/g, '<br/>')
                    .replace(/<br\/><br><br\/>/g, '<br/>');
                return info
            }
            return null;
        },
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show){
                setTimeout(async () => {
                    this.calculatePagesOfDoc()
                    await this.$nextTick()
                    this.calculateRowsPerPage()
                    this.valuesRows = []
                    this.calculatePagesOfDoc()
                    await this.$nextTick()

                    const btnPrint = this.$refs.btnPrint
                    const btnDownload = this.$refs.btnDownload
                    this.loading = true
                    btnPrint.disabled = true
                    btnDownload.disabled = true
                    await this.getImages()
                    btnPrint.disabled = false
                    btnDownload.disabled = false
                    this.loading = false

                }, 0)
            }
        }
    },
    methods: {
        numberWithCommas(x) {
            return numberWithCommas(x);
        },

        hasValidImageExtension(path) {
            if (typeof path !== 'string') {
                return false
            }

            const cleanPath = path.trim().split('?')[0].split('#')[0].toLowerCase()
            return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(cleanPath)
        },

        getValidLogoPath() {
            const businessInfo = this.dataProps?.data?.businessInfo?.[0]
            const logoPaths = [
                businessInfo?.BusinessLogoPath,
                businessInfo?.BranchLogoPath,
            ]

            return logoPaths.find(path => {
                return path != null
                    && path !== ''
                    && path !== 'null'
                    && this.hasValidImageExtension(path)
            }) || null
        },

        calculateRowsPerPage() {
            try {
                let headerHeight = 0
                let tableHeaderHeight = 0
                let footerHeight = 0

                const headerEl = this.$refs.headerSection
                if (headerEl) {
                    headerHeight = Array.isArray(headerEl) ? headerEl[0].offsetHeight : headerEl.offsetHeight
                }

                const tableHeaderEl = this.$refs.tableHeader
                if (tableHeaderEl) {
                    tableHeaderHeight = Array.isArray(tableHeaderEl) ? tableHeaderEl[0].offsetHeight : tableHeaderEl.offsetHeight
                }

                const footerEl = this.$refs.footerSection
                if (footerEl) {
                    footerHeight = Array.isArray(footerEl) ? footerEl[0].offsetHeight : footerEl.offsetHeight
                }

                const availableHeight = this.PAGE_HEIGHT - headerHeight - tableHeaderHeight - footerHeight - 10
                const calculated = Math.max(1, Math.floor(availableHeight / this.ROW_HEIGHT))

                if (calculated > 0) {
                    this.rowsPerPage = calculated
                }
            } catch(e) {
                console.log('Error calculating rows per page:', e)
            }
        },

        calculatePagesOfDoc() {
            let pages = 0
            let rows = 0
            this.valuesRows[pages] = []

            try{
                
                // console.log( 'this.dataProps.data ', this.dataProps.data );

                const maxRows = this.rowsPerPage
                if(this.dataProps.data.items.length <= maxRows){
                    for(let i = 0; i < this.dataProps.data.items.length; i++){
                        this.valuesRows[pages].push(this.dataProps.data.items[i])
                    }
                }
                else{
                    for(let j = 0; j < this.dataProps.data.items.length; j++) {
                        if(rows < maxRows){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.items[j])
                        }
                        else{
                            if(j === this.dataProps.data.items.length - 1) {
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.items[j])
                                break;
                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.items[j])
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                            }
                        }
                    }

                }
                
            }
            catch(err) {
                console.log(err)
            }
            pages = pages + 1
            this.numPages = pages
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
            doc.save(this.dataProps.data.quoteInfo.ID_Invoice+ "_"+this.dataProps.data.quoteInfo.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.quoteInfo.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf"); //Agregado por Juan 13082023

            this.loading = false
        },

        async getImages() {
            this.logoImagePath = null

            const img = this.getValidLogoPath()
            if (!img) {
                return
            }

            const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ "file": img })
            //this.$API.utilities.getImageInBase64({ "file": img }).then(response => {
                //console.log("PRUEBA", response)
            this.logoImagePath = `${logoImageBase64}`
        },

    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
  background-color: #F29D35 !important;
  color: white !important;
}
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

 

</style>
